<div *ngIf="isTicketPDFLink">Descargando PDF</div>
<!-- <div *ngIf="!isTicketPDFLink" class="card border-0 shadow-sm rounded-tix mb-4 w-100">
  <div
    class="card-header bg-white border-bottom rounded-tix py-3 d-flex justify-content-between align-items-center"
    style="
      border-bottom-left-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    "
  >
      <h6 class="m-0">{{ getTitle() }}</h6>
      <div class="dropdown" *ngIf="!orderCancelled">
        <button
          class="btn btn-sm btn-outline-dark select-share-btn"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          data-bs-auto-close="outside"
        >
        <span class="material-symbols-outlined">forward</span>
        Compartir
        </button>
        <div class="dropdown-menu share-dropdown-menu shadow">
          <ul class="share-tickets-list no-scrollbar">
            <li *ngFor="let ticket of tickets" class="d-flex gap-2 justify-center align-items-center">
              <div class="form-check">
                <input
                  [value]="ticket.id"
                  (change)="onShareTicketChange(ticket.id, $event)"
                  [checked]="selectedShareTickets[ticket.id]"
                  class="form-check-input custom-share-checkbox"
                  name="share-ticket"
                  type="checkbox"
                  [id]="ticket.id"
                />
                <label class="form-check-label text-xs" [for]="ticket.id">
                  {{ getTicketShareLabel(ticket) }}
                </label>
              </div>
              <div *ngIf="isTicketShared(ticket.id)" class="marked-as-shared">
                <svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#FFFFFF"><path d="M486-480ZM96-192l216-288L96-768h492q16.85 0 31.92 7.5Q635-753 646-739l194 259-3 3q-24-12-50-18.5t-55-8.5L588-696H240l162 216-162 216h217q-2 18-1 36t4 36H96Zm596 36 130-135-35-33-96.29 99L652-264l-34 34 74 74Zm27.77 108Q640-48 584-104.23q-56-56.22-56-136Q528-320 584.23-376q56.22-56 136-56Q800-432 856-375.77q56 56.22 56 136Q912-160 855.77-104q-56.22 56-136 56Z"/></svg>
              </div>
            </li>
          </ul>
          <hr *ngIf="selectedShareTickets.length">
          <button
            (click)="shareTickets()"
            class="share-btn"
            [disabled]="isLoading"
            *ngIf="selectedShareTickets.length"
            >
            {{ isLoading ? "Cargando..." : "Compartir "  + (selectedShareTickets.length <= 1 ? "un ticket" : selectedShareTickets.length + " tickets")
            }}
          </button>
        </div>
      </div>
  </div>
  <ul class="list-group rounded-0 border-0 rounded-tix text-dark">
    <li
      class="list-group-item border-0 border-bottom text-muted d-flex justify-content-between align-items-center py-3"
      *ngFor="let ticket of tickets ?? []"
    >
      <div class="ticket_information">
        <strong>Ticket ID: {{ ticket.id }}</strong>
        <span
          class="badge rounded-pill ms-2"
          [ngClass]="{
            'text-bg-success': ticket.checkInDate === null,
            'text-bg-danger': ticket.checkInDate !== null || orderCancelled
          }"
          >{{
            orderCancelled
              ? 'Cancelado'
              : ticket.checkInDate !== null
                ? 'Usado'
                : 'Disponible'
          }}</span
        >
        <br />
        {{ ticket.ticketType.name.replace('_', ' ').toUpperCase() }} <br />
        {{ getTicketLabel(ticket) }}
        <div *ngIf="ticket.gift" class="gift">
          <img
            *ngIf="ticket.gift"
            height="45px"
            width="45px"
            [src]="getGiftPicture(ticket.gift?.name)"
            class="object-fit-contain rounded-pill"
          />
          <div
            *ngIf="ticket.gift?.name?.toLowerCase() !== 'brugal'"
            class="badge rounded-pill ms-2"
            style="background: #f9f2e8 !important; color: #000 !important"
          >
            {{ ticket.gift?.name }}
          </div>
        </div>
      </div>
      <button
        *ngIf="!orderCancelled"
        class="btn btn-dark rounded-pill btn-sm py-1 px-3 me-1 border d-flex justify-content-between gap-2 align-items-center"
        data-bs-toggle="modal"
        data-bs-target="#qr_ticket"
        (click)="onClickSeeQR(ticket)"
      >
        <span class="small text-uppercase"> Ver QR </span>
        <span class="material-symbols-outlined p-0 m-0" style="font-size: 24px"
          >qr_code_scanner</span
        >
      </button>
    </li>
  </ul>
</div> -->

<div
  *ngIf="!isTicketPDFLink"
  class="container-fluid px-0"
  style="max-width: 80rem"
>
  <!-- Header con botones -->
  <div class="row g-3 mb-3 d-md-flex" *ngIf="!orderCancelled">
    <div class="col-6 col-md-auto position-relative">
      <button
        class="btn-custom-light w-100 w-md-fit py-3"
        data-bs-toggle="modal"
        data-bs-target="#downloadModal"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="w-5 h-5"
        >
          <line
            x1="10"
            y1="3"
            x2="10"
            y2="14"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          ></line>
          <line
            x1="6"
            y1="11"
            x2="10"
            y2="15"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          ></line>
          <line
            x1="14"
            y1="11"
            x2="10"
            y2="15"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          ></line>
        </svg>
        Descargar
      </button>
    </div>

    <!-- Dropdown de compartir -->
    <div class="col-6 col-md-auto dropdown position-relative">
      <button
        class="btn-custom-light w-100 w-md-fit py-3"
        data-bs-auto-close="outside"
        data-bs-toggle="modal"
        data-bs-target="#shareModal"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="w-5 h-5"
          bis_size='{"x":1002,"y":388,"w":16,"h":16,"abs_x":1002,"abs_y":388}'
        >
          <line
            x1="6"
            y1="14"
            x2="15"
            y2="5"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            bis_size='{"x":1007,"y":392,"w":7,"h":7,"abs_x":1007,"abs_y":392}'
          ></line>
          <line
            x1="11"
            y1="5"
            x2="15"
            y2="5"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            bis_size='{"x":1011,"y":392,"w":3,"h":0,"abs_x":1011,"abs_y":392}'
          ></line>
          <line
            x1="15"
            y1="5"
            x2="15"
            y2="9"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            bis_size='{"x":1014,"y":392,"w":0,"h":3,"abs_x":1014,"abs_y":392}'
          ></line>
        </svg>
        Compartir
      </button>
    </div>

    <!-- Botón de imprimir -->
    <div class="col-6 col-md-auto position-relative">
      <button
        class="btn-custom-light w-100 w-md-fit py-3"
        data-bs-toggle="modal"
        data-bs-target="#printModal"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="w-5 h-5"
        >
          <rect
            x="5"
            y="3"
            width="10"
            height="5"
            stroke="currentColor"
            stroke-width="2"
            stroke-linejoin="round"
          ></rect>
          <rect
            x="3"
            y="8"
            width="14"
            height="7"
            rx="1"
            stroke="currentColor"
            stroke-width="2"
            stroke-linejoin="round"
          ></rect>
          <rect
            x="6"
            y="12"
            width="8"
            height="5"
            stroke="currentColor"
            stroke-width="2"
            stroke-linejoin="round"
          ></rect>
        </svg>
        Imprimir
      </button>
    </div>
    <div class="col-12 col-md-auto" *ngIf="canAddToWallet">
      <app-wallet-passes [slug]="order!.slug"></app-wallet-passes>
    </div>
  </div>

  <!-- Lista de tickets -->
  <div class="row g-3 mb-3">
    <div
      class="col-12"
      *ngFor="let ticket of tickets ?? []; trackBy: trackByTicketId"
    >
      <div class="card card-solid card-bg-transparent p-4 rounded-tix">
        <div class="row g-4">
          <!-- QR Code -->
          <div
            class="col-12 col-sm-auto d-flex justify-content-center justify-content-sm-start"
            *ngIf="!orderCancelled"
          >
            <div
              class="card-bg-transparent rounded-5 d-flex align-items-center justify-content-center p-2 shadow qr-container"
            >
              <app-qr-code
                [data]="ticket.qrcode"
                [size]="600"
                logoUrl="/assets/img/logo-tix-circle.svg"
                [attr.data-ticket-id]="ticket.id"
              >
              </app-qr-code>
            </div>
          </div>

          <!-- Información del ticket -->
          <div class="col-12 col-sm">
            <div class="d-flex flex-column gap-3">
              <!-- Número de ticket y estado -->
              <div
                class="d-flex justify-content-between align-items-start gap-2 flex-wrap"
              >
                <div>
                  <p class="text-muted small mb-1">Número de Ticket</p>
                  <p class="fw-medium mb-0">{{ ticket.id }}</p>
                </div>
                <span
                  class="badge rounded-pill px-3 py-2"
                  [style]="getTicketStatusBadgeStyle(ticket)"
                >
                  {{ getTicketStatusText(ticket) }}
                </span>
              </div>

              <!-- Tipo de ticket -->
              <div>
                <p class="text-muted small mb-1">Tipo de Ticket</p>
                <p class="mb-0">
                  {{ ticket.ticketType.name.replace('_', ' ').toUpperCase() }}
                </p>
              </div>

              <!-- Asiento -->
              <div *ngIf="ticket.isSeat">
                <p class="text-muted small mb-1">Asiento</p>
                <p class="mb-0">{{ getTicketLabel(ticket) }}</p>
              </div>

              <!-- Gift (si existe) -->
              <div
                *ngIf="ticket.gift"
                class="d-flex align-items-center gap-2 mt-2"
              >
                <img
                  [src]="getGiftPicture(ticket.gift?.name)"
                  class="rounded-circle object-fit-contain"
                  height="45"
                  width="45"
                  [alt]="ticket.gift?.name"
                />
                <span
                  *ngIf="ticket.gift?.name?.toLowerCase() !== 'brugal'"
                  class="badge rounded-pill px-3 py-2"
                  style="background-color: #f9f2e8; color: #000"
                >
                  {{ ticket.gift?.name }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Modal de Compartir -->
<div
  class="modal fade"
  id="shareModal"
  tabindex="-1"
  aria-labelledby="shareModalLabel"
  aria-hidden="true"
  (hidden.bs.modal)="clearShareSelection()"
>
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content rounded-tix">
      <!-- Modal Header -->
      <div class="modal-header border-0 pb-2">
        <h5 class="modal-title fw-semibold" id="shareModalLabel">
          Compartir Tickets
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body pt-0">
        <div class="d-flex flex-column justify-content-between gap-2 mb-3">
          <p class="text-muted mb-0">
            Selecciona los tickets que deseas compartir
          </p>
          <button
            type="button"
            class="btn-custom-light"
            (click)="toggleSelectAll('share')"
          >
            {{
              isAllSelected('share')
                ? 'Deseleccionar todos'
                : 'Seleccionar todos'
            }}
          </button>
        </div>

        <!-- Lista de tickets -->
        <div class="tickets-list">
          <div
            *ngFor="let ticket of tickets; trackBy: trackByTicketId"
            class="ticket-card d-flex align-items-center gap-3 p-3 mb-3 border rounded-tix"
            (click)="onTicketCardClick(ticket.id, 'share', $event)"
            [class.disabled-card]="orderCancelled || isTicketUsed(ticket)"
          >
            <!-- Radio button -->
            <div class="form-check" (click)="$event.stopPropagation()">
              <input
                class="form-check-input ticket-radio"
                type="checkbox"
                [value]="ticket.id"
                [id]="'modal-share-' + ticket.id"
                [checked]="selectedShareTickets.includes(ticket.id)"
                (change)="onShareTicketChange(ticket.id, $event)"
                [disabled]="orderCancelled || isTicketUsed(ticket)"
              />
            </div>

            <!-- Información del ticket -->
            <div class="flex-grow-1">
              <div
                class="d-flex justify-content-between align-items-start gap-2"
              >
                <div>
                  <p class="mb-0 fw-medium">Ticket ID: {{ ticket.id }}</p>
                  <p class="mb-0 text-muted small">
                    {{ ticket.ticketType.name.replace('_', ' ') }}
                  </p>
                  <p class="mb-0 text-muted small" *ngIf="ticket.isSeat">
                    Asiento {{ getTicketLabel(ticket) }}
                  </p>
                </div>
                <!-- Badge de estado -->
                <span
                  class="badge rounded-pill px-3 py-2"
                  [style]="getTicketStatusBadgeStyleWithShared(ticket)"
                >
                  {{ getTicketStatusTextWithShared(ticket) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Footer -->
      <div
        class="modal-footer border-0 pt-0 justify-content-between flex-column flex-md-row"
      >
        <button
          type="button"
          class="btn-custom-light order-2 order-md-1"
          style="height: 36px"
          data-bs-dismiss="modal"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="btn-custom-dark rounded-pill order-1 order-md-2"
          style="height: 36px"
          [disabled]="selectedShareTickets.length === 0 || isLoading"
          (click)="shareTickets()"
        >
          <ng-container *ngIf="isLoading">
            <span
              class="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            Compartiendo...
          </ng-container>

          <ng-container *ngIf="!isLoading">
            {{ 'Compartir (' + selectedShareTickets.length + ')' }}
          </ng-container>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Descargar -->
<div
  class="modal fade"
  id="downloadModal"
  tabindex="-1"
  aria-labelledby="downloadModalLabel"
  aria-hidden="true"
  (hidden.bs.modal)="clearDownloadSelection()"
>
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content rounded-tix">
      <!-- Modal Header -->
      <div class="modal-header border-0 pb-2">
        <h5 class="modal-title fw-semibold" id="downloadModalLabel">
          Descargar Tickets
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body pt-0">
        <div class="d-flex flex-column justify-content-between gap-2 mb-3">
          <p class="text-muted mb-0">
            Selecciona los tickets que deseas descargar
          </p>
          <button
            type="button"
            class="btn-custom-light"
            (click)="toggleSelectAll('download')"
          >
            {{
              isAllSelected('download')
                ? 'Deseleccionar todos'
                : 'Seleccionar todos'
            }}
          </button>
        </div>

        <!-- Lista de tickets -->
        <div class="tickets-list">
          <div
            *ngFor="let ticket of tickets; trackBy: trackByTicketId"
            class="ticket-card d-flex align-items-center gap-3 p-3 mb-3 border rounded-tix"
            (click)="onTicketCardClick(ticket.id, 'download', $event)"
            [class.disabled-card]="orderCancelled || isTicketUsed(ticket)"
          >
            <!-- Checkbox -->
            <div class="form-check" (click)="$event.stopPropagation()">
              <input
                class="form-check-input ticket-radio"
                type="checkbox"
                [value]="ticket.id"
                [id]="'modal-download-' + ticket.id"
                [checked]="selectedDownloadTickets.includes(ticket.id)"
                (change)="onDownloadTicketChange(ticket.id, $event)"
                [disabled]="orderCancelled || isTicketUsed(ticket)"
              />
            </div>

            <!-- Información del ticket -->
            <div class="flex-grow-1">
              <div
                class="d-flex justify-content-between align-items-start gap-2"
              >
                <div>
                  <p class="mb-0 fw-medium">Ticket ID: {{ ticket.id }}</p>
                  <p class="mb-0 text-muted small">
                    {{ ticket.ticketType.name.replace('_', ' ') }}
                  </p>
                  <p class="mb-0 text-muted small" *ngIf="ticket.isSeat">
                    Asiento {{ getTicketLabel(ticket) }}
                  </p>
                </div>
                <!-- Badge de estado -->
                <span
                  class="badge rounded-pill px-3 py-2"
                  [style]="getTicketStatusBadgeStyle(ticket)"
                >
                  {{ getTicketStatusText(ticket) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Footer -->
      <div
        class="modal-footer border-0 pt-0 justify-content-between flex-column flex-md-row"
      >
        <button
          type="button"
          class="btn-custom-light order-2 order-md-1"
          style="height: 36px"
          data-bs-dismiss="modal"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="btn-custom-dark rounded-pill order-1 order-md-2"
          style="height: 36px"
          [disabled]="selectedDownloadTickets.length === 0 || isLoading"
          (click)="downloadSelectedTickets()"
        >
          <ng-container *ngIf="isLoading">
            <span
              class="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            Descargando...
          </ng-container>

          <ng-container *ngIf="!isLoading">
            {{ 'Descargar (' + selectedDownloadTickets.length + ')' }}
          </ng-container>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Imprimir -->
<div
  class="modal fade"
  id="printModal"
  tabindex="-1"
  aria-labelledby="printModalLabel"
  aria-hidden="true"
  (hidden.bs.modal)="clearPrintSelection()"
>
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content rounded-tix">
      <!-- Modal Header -->
      <div class="modal-header border-0 pb-2">
        <h5 class="modal-title fw-semibold" id="printModalLabel">
          Imprimir Tickets
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body pt-0">
        <div class="d-flex flex-column justify-content-between gap-2 mb-3">
          <p class="text-muted mb-0">
            Selecciona los tickets que deseas imprimir
          </p>
          <button
            type="button"
            class="btn-custom-light"
            (click)="toggleSelectAll('print')"
          >
            {{
              isAllSelected('print')
                ? 'Deseleccionar todos'
                : 'Seleccionar todos'
            }}
          </button>
        </div>

        <!-- Lista de tickets -->
        <div class="tickets-list">
          <div
            *ngFor="let ticket of tickets; trackBy: trackByTicketId"
            class="ticket-card d-flex align-items-center gap-3 p-3 mb-3 border rounded-tix"
            (click)="onTicketCardClick(ticket.id, 'print', $event)"
            [class.disabled-card]="orderCancelled || isTicketUsed(ticket)"
          >
            <!-- Checkbox -->
            <div class="form-check" (click)="$event.stopPropagation()">
              <input
                class="form-check-input ticket-radio"
                type="checkbox"
                [value]="ticket.id"
                [id]="'modal-print-' + ticket.id"
                [checked]="selectedPrintTickets.includes(ticket.id)"
                (change)="onPrintTicketChange(ticket.id, $event)"
                [disabled]="orderCancelled || isTicketUsed(ticket)"
              />
            </div>

            <!-- Información del ticket -->
            <div class="flex-grow-1">
              <div
                class="d-flex justify-content-between align-items-start gap-2"
              >
                <div>
                  <p class="mb-0 fw-medium">Ticket ID: {{ ticket.id }}</p>
                  <p class="mb-0 text-muted small">
                    {{ ticket.ticketType.name.replace('_', ' ') }}
                  </p>
                  <p class="mb-0 text-muted small" *ngIf="ticket.isSeat">
                    Asiento {{ getTicketLabel(ticket) }}
                  </p>
                </div>
                <!-- Badge de estado -->
                <span
                  class="badge rounded-pill px-3 py-2"
                  [style]="getTicketStatusBadgeStyle(ticket)"
                >
                  {{ getTicketStatusText(ticket) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Footer -->
      <div
        class="modal-footer border-0 pt-0 justify-content-between flex-column flex-md-row"
      >
        <button
          type="button"
          class="btn-custom-light order-2 order-md-1"
          style="height: 36px"
          data-bs-dismiss="modal"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="btn-custom-dark rounded-pill order-1 order-md-2"
          style="height: 36px"
          [disabled]="selectedPrintTickets.length === 0 || isLoading"
          (click)="printSelectedTickets()"
        >
          <ng-container *ngIf="isLoading">
            <span
              class="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            Preparando...
          </ng-container>

          <ng-container *ngIf="!isLoading">
            {{ 'Imprimir (' + selectedPrintTickets.length + ')' }}
          </ng-container>
        </button>
      </div>
    </div>
  </div>
</div>

